// removed by extract-text-webpack-plugin
module.exports = {"valueSection":"src-templates-landing-components-valueSection----valueSection-module---valueSection---2vk7y","valueSectionContainer":"src-templates-landing-components-valueSection----valueSection-module---valueSectionContainer---2Thyj","column":"src-templates-landing-components-valueSection----valueSection-module---column---3CvUg","columnWrapper":"src-templates-landing-components-valueSection----valueSection-module---columnWrapper---3LU9U"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/landing/components/valueSection/valueSection.module.pcss
// module id = 309
// module chunks = 104033720589488